import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Landscape dynamics has a crucial role in the ecological processes
              and sustainability of natural resources. Understanding of
              landscape dynamics aids in planning and prudent management of
              natural resources. However, unplanned rapid urbanization during
              the post 1990&rsquo;s consequent to the globalization has driven
              anthropogenic activities leading to the alterations in the
              landscape structure, impacting the ecological process evident from
              the increase in land surface temperatures, alterations in the
              hydrologic regime, etc. Thus, land surface temperature being
              sensitive to land use dynamics, has become a vital factor in the
              regional climate change studies. The current study explores the
              relationship between biophysical parameters of earth to sub pixel
              thermal variations based on agro climatic zones of Karnataka. The
              general trend of temperature of the region with different land use
              class was established which indicates rise in temperature in the
              recent period. The study identifies the hotspot zones of higher
              temperature with the insights of land uses across the agro
              climatic zones of Karnataka.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Keywords: </strong>Landscape dynamics; Land use land
              cover; Land Surface Temperature; Remote sensing; GIS
            </p>
            <p>&nbsp;</p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
